import { Box, Collapse, Flex } from '@chakra-ui/react'

import { useFirebase } from '@chem-po/firebase-web'
import { PopUpMessageContext, ScreenContext, useAuth, useContentWidth } from '@hb/react'
import React, { useCallback, useContext } from 'react'
import { useCookies } from 'react-cookie'
import { Navigate, useParams } from 'react-router'
import { useNavigate } from '../../hooks/navigation'
import { signOut } from '../../backend/auth/signIn'
import { ActionButton, SolidActionButton } from '../Buttons'
import { Container } from '../Container'
import { FloatingContainer } from '../Containers'
import { Header } from '../Header'
import { SignInContent } from './SignInContent'

export const SignInView: React.FC = () => {
  const [{ inviteId }] = useCookies()

  const navigate = useNavigate()
  const { enrollingUser, authUser } = useAuth()
  const { width } = useContext(ScreenContext)
  const contentWidth = useContentWidth(width, 400)
  const { auth } = useFirebase()

  const [isLoggingOut, setIsLoggingOut] = React.useState(false)
  const { showError } = useContext(PopUpMessageContext)

  const handleSignOut = useCallback(async () => {
    setIsLoggingOut(true)
    try {
      await signOut(auth)
    } catch (err: any) {
      showError(err.message)
    }
    setIsLoggingOut(false)
  }, [showError, auth])

  const isSignedIn = !!authUser || !!enrollingUser

  return (
    <Container>
      <FloatingContainer
        style={{
          width: contentWidth,
          padding: 0,
        }}>
        {!isSignedIn ? <SignInContent onClose={() => navigate('/pregnancy')} /> : null}
        <Collapse in={isSignedIn}>
          <Box pt={2} pb={3} px={5}>
            <Header
              style={{
                fontSize: '18px',
                color: '#222222',
                fontFamily: 'Hero-New',
              }}>
              Welcome to Hamilton Billing!
            </Header>
            <Flex gap={2} direction="column" mr="auto">
              <SolidActionButton
                style={{
                  color: 'white',
                  fontSize: '14px',
                  marginTop: '10px',
                  marginRight: 'auto',
                }}
                onClick={() => navigate('/pregnancy')}>
                Your Assessment
              </SolidActionButton>
              <ActionButton
                size="sm"
                isLoading={isLoggingOut}
                style={{
                  marginRight: 'auto',
                }}
                onClick={handleSignOut}>
                Log Out
              </ActionButton>
            </Flex>
          </Box>
        </Collapse>
        {inviteId ? (
          <span
            style={{
              padding: '0 10px',
              fontWeight: 600,
              color: '#777',
              fontSize: '12px',
              paddingTop: '5px',
              paddingBottom: '10px',
            }}>
            INVITE ID: {inviteId.toUpperCase()}
          </span>
        ) : null}
      </FloatingContainer>
    </Container>
  )
}

export const SignInRedirect: React.FC = () => {
  const params = useParams()
  const [, setCookie] = useCookies()
  const { inviteId } = params
  if (inviteId) {
    setCookie('inviteId', inviteId, { path: '/', sameSite: 'strict' })
  }
  return <Navigate replace to="/" />
}
